// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__35wCJ","content":"ManualTimeModal_content__2g2kk"};